import React from 'react';

import {ResultIcon} from './resultTypes';
import Link from '../Link';

// Map a stored recent search to its canonical content type.
const getType = (search) => {
  if (search.type === 'tag') return search.item.type; // 'company' | 'role'
  if (search.type === 'track') return 'course';
  return search.type;
};

const getContents = (search) => {
  switch (search.type) {
    case 'tag':
      return search.item.name;
    case 'track':
    case 'course':
    case 'lesson':
    case 'resource':
    case 'blog':
      return search.item.title;
    case 'question':
      return search.item.data.title;
    case 'coach':
      return `${search.item.Name}, ${search.item.Title}`;
    case 'guide':
      return search.item.name;
    default:
      throw new Error(`Unknown search type: ${search.type} rendered in RecentSearch`);
  }
};

const RecentSearch = ({search, onClick}) => {
  const type = getType(search);
  // Only companies keep their logo; everything else uses the type icon.
  const image = type === 'company' ? search.item.image_url : null;

  return (
    <Link
      href={search.href}
      onClick={() => onClick(search)}
      className="flex items-center gap-3 mx-2 px-3 py-2 text-base text-gray-800 sm:font-medium rounded-lg transition ease-in-out duration-150 hover:bg-gray-50"
    >
      <ResultIcon type={type} image={image} />
      <span className="truncate">{getContents(search)}</span>
    </Link>
  );
};

const RecentSearches = ({recent = [], onClick, onClear}) => (recent.length ? (
  <div className="-mx-4 border-t border-gray-200">
    <div className="flex items-center justify-between px-5 pt-4 pb-1">
      <h3 className="text-base font-semibold text-gray-900">Recent Searches</h3>
      <button
        type="button"
        onClick={onClear}
        className="text-sm font-medium text-gray-500 hover:text-gray-700"
      >
        Clear all
      </button>
    </div>
    <div className="py-2">
      {recent.map((search) => (
        <RecentSearch
          search={search}
          onClick={onClick}
          key={search.href}
        />
      ))}
    </div>
  </div>
) : null);

export default RecentSearches;
